import { render, staticRenderFns } from "./myApproval.vue?vue&type=template&id=62c128be&scoped=true"
import script from "./myApproval.vue?vue&type=script&lang=js"
export * from "./myApproval.vue?vue&type=script&lang=js"
import style0 from "./myApproval.vue?vue&type=style&index=0&id=62c128be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c128be",
  null
  
)

export default component.exports